import Call from '../Call.v3';

import qs from 'querystring';

const AdkPreDefinedDomains = {
    get: async (filters = {}) => Call(`adk/pre_defined_domains?${qs.stringify(filters)}`),
    remove: async (entity = {}) => Call(`adk/pre_defined_domains/${entity.id}`, 'DELETE'),
    update: async (entity = {}) => Call(`adk/pre_defined_domains`, 'PUT', entity),
    create: async (entity = {}) => Call(`adk/pre_defined_domains`, 'POST', entity),
};

export default AdkPreDefinedDomains;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkPreDefinedDomains.js